module.exports = __webpack_public_path__ + "img/association_map.52461d73.svg";